import AOS from "aos";
import Swiper, { Navigation, EffectFade } from "swiper";
// import 'slick-carousel';
import "@fancyapps/fancybox";
import "@lottiefiles/lottie-player";

export default {
  init() {
    jQuery("body").addClass("loading");

    window.onscroll = header;
    function header() {
      if (
        document.body.scrollTop > 0 ||
        document.documentElement.scrollTop > 0
      ) {
        document.querySelector("header.banner").classList.add("scrolled");
      } else {
        document.querySelector("header.banner").classList.remove("scrolled");
      }
    }

    jQuery(document).ready(function ($) {
      AOS.init();

      setTimeout(function () {
        AOS.refresh();
        $("body").removeClass("loading");
      }, 700);
    });
  },
  finalize() {
    $(".hamburger").on("click", function () {
      $(this).toggleClass("is-active");
      $(".nav-primary").toggleClass("open");
      $("body").toggleClass("no-scroll");
    });

    $("header #menu-primary-navigation li.menu-item-has-children").each(
      function () {
        $(this).append('<div class="child-opener"></div>');
      }
    );

    $("header #menu-primary-navigation").on(
      "click",
      "li.menu-item-has-children > .child-opener",
      function () {
        $(this).parent(".menu-item-has-children").toggleClass("opened");
      }
    );

    $(".search").on("click", function (e) {
      if ($(e.target).hasClass("search-ico") && $(this).hasClass("open")) {
        $("#search-form-nav").submit();
      } else if ($(e.target).hasClass("search-ico")) {
        $(this).addClass("open");
        $("#search-input-nav").focus();
      } else if ($(e.target).hasClass("close-search")) {
        $(this).removeClass("open");
      }
    });

    $("#btn-close-nl").on("click", function () {
      setCookie("nl", "1", 60);

      $(this)
        .parent(".btn-nl")
        .fadeOut(function () {
          $(this).remove();
        });
    });

    $("#btn-open-nl-modal").on("click", function () {
      setCookie("nl", "1", 60);
      $("#nlModal").modal("show");

      $(this)
        .parent(".btn-nl")
        .fadeOut(function () {
          $(this).remove();
        });
    });

    new Swiper(".header-slider", {
      modules: [Navigation, EffectFade],
      loop: true,
      effect: "fade",
      speed: 1000,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      slidesPerView: 1,
      centeredSlides: true,
      autoplay: false,
      disableOnInteraction: false,
      autoHeight: false,
    });

    var rangeOne = document.querySelector('input[id="animalFromSlider"]'),
      rangeTwo = document.querySelector('input[id="animalToSlider"]'),
      outputOne = document.getElementById("animalFrom"),
      outputTwo = document.getElementById("animalTo"),
      inclRange = document.querySelector(".incl-range"),
      updateView = function () {
        if (this.getAttribute("id") === "animalFromSlider") {
          outputOne.value = this.value;
          outputOne.style.left =
            (this.value / this.getAttribute("max")) * 100 + "%";
        } else {
          outputTwo.style.left =
            (this.value / this.getAttribute("max")) * 100 + "%";
          outputTwo.value = this.value;
        }
        if (parseInt(rangeOne.value) > parseInt(rangeTwo.value)) {
          inclRange.style.width =
            ((rangeOne.value - rangeTwo.value) / this.getAttribute("max")) *
              100 +
            "%";
          inclRange.style.left =
            (rangeTwo.value / this.getAttribute("max")) * 100 + "%";
        } else {
          inclRange.style.width =
            ((rangeTwo.value - rangeOne.value) / this.getAttribute("max")) *
              100 +
            "%";
          inclRange.style.left =
            (rangeOne.value / this.getAttribute("max")) * 100 + "%";
        }
      };

    if (rangeOne && rangeTwo) {
      updateView.call(rangeOne);
      updateView.call(rangeTwo);
      $('input[type="range"]')
        .on("mouseup", function () {
          this.blur();
        })
        .on("mousedown input", function () {
          updateView.call(this);
        });
    }

    /* if($('input[type=radio][name="animalGroup"]').length) {
      $('input[type=radio][name="animalGroup"]').on('change', function(){
        $(this).parents('form').submit();
      });
    }

    if($('input[type=radio][name="animalGender"]').length) {
      $('input[type=radio][name="animalGender"]').on('change', function(){
        $(this).parents('form').submit();
      });
    } */

    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    /* function getCookie(cname) {
      let name = cname + '=';
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    } */

    // Easter animation
    const containerEasterFlowersAnimation = document.querySelector(
      ".header-animation-container.--flowers"
    );

    if (containerEasterFlowersAnimation) {
      const colors = [
        "#FFDD57", // Yellow
        "#FF6347", // Tomato Red
        "#6A5ACD", // Slate Blue
        "#32CD32", // Lime Green
        "#FF69B4", // Hot Pink
        "#FAD02E", // Pastel Yellow
        "#F28D35", // Pastel Orange
        "#D4A5A5", // Pastel Pink
        "#A5D8FF", // Pastel Blue
        "#B8E994", // Mint Green
      ];

      const createFlower = () => {
        const innerContainer = document.querySelector(
          ".header-animation.--flowers"
        );
        const flower = document.createElement("div");
        flower.classList.add("header-animation-flower");

        const size = Math.random() * 15 + 20; // Random size between 20px and 35px
        const color = colors[Math.floor(Math.random() * colors.length)];

        flower.style.width = `${size}px`;
        flower.style.height = `${size * 1.5}px`;
        flower.style.left = `${Math.random() * 100}%`;
        flower.style.animation = `falling ${
          Math.random() * 5 + 5
        }s linear infinite`;

        flower.innerHTML = generateFlowerSVG(size, color);

        innerContainer.appendChild(flower);

        setTimeout(() => {
          flower.remove();
        }, 5000);
      };

      const generateFlowerSVG = (size, fillColor) => {
        return `
          <svg width="${size}" height="${
          size * 1.5
        }" viewBox="0 0 2122 2122" xmlns="http://www.w3.org/2000/svg">
            <path style="fill:${fillColor}" d="M1867.49 816.42c-4.698-1.319-10.201-4.014-10.024-8.518.133-3.385 3.523-5.777 6.609-7.623a447 447 0 0 1 12.265-7.075a452 452 0 0 1 22.914-11.896c-43.156-76.946-128.508-129.856-223.744-145.125l-.04-.006c-34.941-5.598-71.209-6.132-107.213-.924-115.135 16.655-212.691 86.65-291.382 169.513 35.406-93.726 51.939-194.988 24.446-292.343-5.791-20.507-13.502-40.311-22.869-59.172-50.302-101.293-148.377-175.359-253.541-184.832.873 13.015-.338 26.171-3.662 38.785-1.191 4.522-3.779 9.865-8.457 9.867-3.514.001-6.122-3.136-8.152-6.005a427 427 0 0 1-7.795-11.41a422 422 0 0 1-14.108-22.966c-4.641 3.209-9.002 7.005-13.213 10.848-56.116 51.227-98.548 119.527-123.152 194.793-15.781 48.276-24.228 99.417-24.246 150.759-.022 64.796 13.333 129.333 37.806 188.434-99.047-72.909-216.943-129.964-342.527-123.827h-.005q-.922.044-1.843.095c-139.262 7.489-265.991 96.137-303.425 213.977 15.952 3.539 31.195 10.3 44.455 19.852 3.795 2.734 7.855 7.064 6.181 11.431-1.26 3.282-5.122 4.591-8.528 5.458a425 425 0 0 1-13.446 3.188a422 422 0 0 1-28.191 5.197c2.092 4.389 4.599 8.675 7.166 12.861 43.544 71.02 110.88 130.729 189.963 171.148 40.112 20.501 83.246 36.04 127.83 45.575 89.278 19.093 183.262 13.96 267.439-12.669-84.755 41.539-158.999 108.655-208.417 191.308-26.797 44.818-46.078 93.908-57.442 144.436l-.016.07c-18.104 80.547-16.086 164.746 7.702 241.124 1.204 3.866 2.484 7.75 3.965 11.525 15.012-10.213 32.023-17.498 49.805-21.18 5.253-1.088 12.065-1.161 14.458 3.642 1.799 3.61-.091 7.891-2 11.444a484 484 0 0 1-25.37 41.949c113.894 54.808 263.455 30.887 365.695-55.592l.029-.023a341 341 0 0 0 12.333-10.955c93.686-87.373 130.64-215.826 141.622-341.544 25.729 106.973 73.569 210.592 161.249 279.186a343 343 0 0 0 37.154 25.3c100.619 59.311 227.958 66.165 322.898 13.901-10.446-12.931-18.553-27.755-23.687-43.567-1.632-5.028-2.44-11.689 2.006-14.551 3.342-2.151 7.737-.763 11.422.723a477 477 0 0 1 47.618 22.342c2.188-5.855 3.617-12.141 4.859-18.364 15.403-77.212 8.215-160.534-18.642-238.268l-.001-.005c-15.879-45.955-38.63-89.957-67.657-129.587-40.942-55.899-93.933-102.602-153.085-136.68 71.004.911 143.706-13.11 210.303-41.981 41.835-18.135 80.989-42.038 116.061-70.304 66.571-53.652 118.431-123.028 145.978-198.542 2.183-5.981 4.231-12.112 5.35-18.239-14.069.476-28.228-1.176-41.701-4.958"/>
            <path style="fill:#f192ad" d="M1729.202 847.042c-43.463-82.213-149.773-129.685-253.187-114.725-118.864 17.195-213.021 109.345-280.017 199.038 17.693 13.477 31.357 32.34 39.065 53.285 54.892-23.167 115.876-34.714 175.003-45.427l-170.281 61.886c1.614 7.766 2.406 15.69 2.294 23.62v.017q-.012.811-.036 1.623q-.007.213-.016.425q-.02.625-.047 1.251a98 98 0 0 1-.092 1.704l-.01.152a100 100 0 0 1-.118 1.64l-.008.108-.006.089 270.742-17.919c-89.434 21.454-182.781 42.88-272.973 32.734l-.261 1.326c-.463 2.335-.928 4.669-1.341 7.007q-.089.5-.174 1.002c-.85 5.01-1.422 10.034-1.168 15.107.112 2.231.383 4.441.754 6.637q.186 1.098.403 2.193l.273 1.337c.297 1.402.624 2.8.964 4.197l.134.545q.24.976.486 1.953l.562 2.228.279 1.114a266 266 0 0 1 .813 3.346l.257 1.117.255 1.159c1.28.544 2.557 1.097 3.844 1.617a315 315 0 0 0 16.015 5.976 327 327 0 0 0-19.096-3.624c.34 2.038.594 4.087.712 6.154a49 49 0 0 1-1.092 13.379 54 54 0 0 1-.575 2.349c-1.049 3.891-2.541 7.667-4.398 11.305a67 67 0 0 1-2.399 4.3 77 77 0 0 1-4.192 6.187 83 83 0 0 1-3.146 3.942 93 93 0 0 1-6.079 6.515q-.615.601-1.241 1.193l-.453.423q-.417.39-.837.776q-.23.21-.462.418a92 92 0 0 1-1.312 1.168 143 143 0 0 1-.937.811l-.375.32q-.539.458-1.084.908l-.255.212a119 119 0 0 1-4.276 3.353l-.022.016c45.588 44.65 80.53 101.573 113.814 156.836l-127.499-147.903-.292.168q-.466.27-.931.537l-.49.279q-.514.293-1.032.584l-.324.183q-.567.318-1.135.633q-.178.1-.357.197a285 285 0 0 1-2.55 1.392l-.393.213-1.094.585-.346.185q-.571.304-1.144.606l-.337.178q-.52.275-1.042.547l-.51.266-1.011.526-.421.218q-.525.273-1.052.543l-.493.254-.799.411-.824.422-.565.289-.936.477-.538.274-.832.424-2.41 1.224-1.491.757-.342.173 117.804 257.589c-53.363-78.286-108.17-160.464-129.444-251.551l-.013.006q-.693.372-1.384.747l-.224.121-1.191.652-.366.2-1.071.594-.46.256a216 216 0 0 0-5.92 3.435 168 168 0 0 0-4.359 2.714 155 155 0 0 0-2.854 1.884 136 136 0 0 0-5.068 3.603l-.993.751q-.989.756-1.963 1.534-1.461 1.167-2.886 2.388c-.972.833-1.929 1.685-2.878 2.547q-.711.648-1.416 1.303l-.705.656q-.704.657-1.404 1.319l-1.041.982-1.689 1.593a187 187 0 0 1-5.135 4.687l-.963.83-.795.67c-1.828 1.524-3.71 2.974-5.685 4.304q-.794.536-1.608 1.044a51 51 0 0 1-7.37 3.796c12.124 109.561 46.427 231.366 137.891 302.92 82.522 64.559 200.776 75.33 282.518 24.181 4.986-3.12 9.913-6.505 13.546-11.162 5.167-6.624 7.324-15.29 9.022-23.8 18.589-93.18-6.198-198.093-65.451-278.99-45.46-62.066-110.505-109.182-181.122-133.188 75.409 16.63 159.576 8.76 233.755-23.397 91.952-39.862 166.834-116.454 198.734-203.897 2.913-7.985 5.515-16.324 4.505-24.378-.714-5.664-3.18-10.874-5.83-15.888"/>
          </svg>
        `;
      };

      setInterval(createFlower, 600); // Spawn interval
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js